/**
 * Map API counselor_student_messages row → ChatMessage shape.
 * Critical: message_metadata must survive this hop or Chat cards never appear.
 */
export function mapCounselorThreadMessage(msg) {
	return {
		id: msg.id,
		from: msg.sender_type === 'counselor' ? 'admin' : 'user',
		text: msg.message_text || msg.text || '',
		metadata: msg.message_metadata ?? msg.metadata ?? null,
		timestamp: msg.created_at || msg.timestamp,
		isRead: msg.is_read ?? msg.isRead ?? false,
	}
}
